import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-center-card-layout',
  standalone: true,
  imports: [MatCardModule, RouterModule],
  templateUrl: './center-card-layout.component.html',
  styleUrl: './center-card-layout.component.scss',
})
export class CenterCardLayoutComponent {}
